import type { ID } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'

import type { ArtBoardState } from './types'

// The artboard is off for a reason other than the assistant's turn: saving is
// down, or the activity history is open and what is on screen may be the past.
export const isArtBoardHalted = (artboard: ArtBoardState) =>
  artboard.socketOffline ||
  artboard.saveFailed ||
  artboard.activityHistory ||
  artboard.mode === 'activity_history'

export const isArtBoardDisabled = (artboard: ArtBoardState) =>
  isArtBoardHalted(artboard) || artboard.aiGenerating

// A page dropped onto its direct parent or child trades places with it
// instead of moving under it.
export const isDirectRelative = (
  state: Pick<AppState, 'relations'>,
  id: ID,
  targetId: ID
) => {
  const { dependencies } = state.relations
  const item = dependencies[id]
  const target = dependencies[targetId]

  return (
    item?.type === 'node' &&
    target?.type === 'node' &&
    (item.parents.includes(targetId) || target.parents.includes(id))
  )
}
